import React from "react";
import LegalPageLayout from "../components/LegalPageLayout";
import { termsContent, getDateLocale } from "../translations/legalContent";

export default function TermsOfService() {
  return (
    <LegalPageLayout
      titleKey="termsTitle"
      renderContent={(lang) => {
        const content = termsContent[lang] || termsContent.tr;
        const locale = getDateLocale(lang);

        return (
          <>
            <p>
              {content.lastUpdatedLabel} {new Date().toLocaleDateString(locale)}
            </p>

            {content.sections.map((section, i) => (
              <section key={i}>
                <h2>{section.title}</h2>
                {section.paragraphs?.map((p, j) => (
                  <p key={j}>{p}</p>
                ))}
                {section.items && (
                  <ul>
                    {section.items.map((item, k) => (
                      <li key={k}>{item}</li>
                    ))}
                  </ul>
                )}
              </section>
            ))}
          </>
        );
      }}
    />
  );
}
